import { Suspense, type ReactNode } from 'react';
import { Outlet } from 'react-router';
import { ErrorBoundary, Skeleton } from '@/lib/ui';
import { Breadcrumb } from './breadcrumb';
import { Fab } from './fab';
import { GlobalNav } from './global-nav';
import { Sidebar } from './sidebar';

export function AppShell({ navRight }: { navRight?: ReactNode }) {
  return (
    <div id="app">
      <GlobalNav right={navRight} />
      <div id="body-wrapper">
        <Sidebar />
        <main id="main-content">
          <Breadcrumb />
          <div id="content-area" role="main">
            <ErrorBoundary><Suspense fallback={<Skeleton lines={8} />}><Outlet /></Suspense></ErrorBoundary>
          </div>
        </main>
        <Fab />
      </div>
    </div>
  );
}
